import { BaseContainerModel } from '../../base-container.model';
import { bl_b2b_ipo_xdo_igrn_queue_RowClass } from '../../../dbschema/index';

export class IpoXdoIgrnQueueContainer extends BaseContainerModel {
  bl_b2b_ipo_xdo_igrn_queue: bl_b2b_ipo_xdo_igrn_queue_RowClass = new bl_b2b_ipo_xdo_igrn_queue_RowClass();
}
